module.exports = __webpack_public_path__ + "static/assets/56dcdd9398d39e96e5fbd9c2ad618dbf.png";